import React from 'react';
import { PropTypes as PT } from 'prop-types';
import _compact from 'lodash/compact';
import SVG from 'react-inlinesvg';
import alertIcon from '@lifesize/ux-assets/vectors/svgIcons/alert.svg';
import classes from './ModalInput.module.scss';

const ModalInput = (props) => {
  const {
    autoFocus,
    children,
    input,
    label,
    labelClassName,
    placeholder,
    required,
    subText,
    type
  } = props;

  let style;

  if (props.meta.touched && !props.meta.active && props.meta.error) {
    style = input.value ?
      classes.modalInputFieldsetErrorWithInput : classes.modalInputFieldsetError;
  } else {
    style = input.value ? classes.modalInputFieldsetWithInput : classes.modalInputFieldset;
  }

  const labelClasses = _compact([
    labelClassName,
    required && classes.requiredLabel
  ]).join(' ');

  const errorBoxClasses = _compact([
    classes.errorBox,
  ]).join(' ');

  const onFocus = (e) => {
    if (autoFocus) {
      const val = e.target.value;
      e.target.value = '';
      e.target.value = val;
      e.target.scrollLeft = e.target.scrollWidth;
    }
  };

  return (
    <fieldset className={style}>
      {children}
      <input
        {...input}
        autoComplete="off"
        autoFocus={autoFocus}
        className={`${props.meta.active ? '' : classes.blurred}`}
        data-testid={props.dataTestId ? props.dataTestId : 'modal-input'}
        maxLength={props.maxlength ? props.maxlength : null}
        onFocus={onFocus}
        placeholder={placeholder}
        required={required}
        type={type}
      />
      <label className={labelClasses} htmlFor={input.name}>{label}</label>
      {(input.value || (props.meta.touched && !props.meta.active)) &&
        props.meta.error &&
        <div className={errorBoxClasses}>
          <span>{props.meta.error}</span>
          <SVG src={alertIcon} data-testid="alertIcon" />
        </div>}
      {subText && <div className={classes.subText}>{subText}</div>}
    </fieldset>
  );
};

ModalInput.propTypes = {
  autoComplete: PT.string,
  autoFocus: PT.bool,
  children: PT.element,
  dataTestId: PT.string,
  input: PT.object,
  label: PT.string,
  labelClassName: PT.string,
  maxlength: PT.number,
  meta: PT.object,
  placeholder: PT.string,
  required: PT.bool,
  subText: PT.string,
  toolTip: PT.string,
  type: PT.string
};

export default ModalInput;
